<template>
  <b-tab id="tab2" title="เอกสารแนบ">
    <b-tabs @activate-tab="onActiveTabChange">
      <b-tab id="tab-attach-1" title="เอกสารผู้ร้อง">
        <b-row
          v-if="
            this.attachFiles.length == 0 && this.attachFilesType2.length == 0
          "
        >
          <b-col class="text-center">
            <h1>ไม่พบรายการเอกสารแนบ</h1>
          </b-col></b-row
        >

        <b-row v-if="this.attachFiles !== null && this.attachFiles.length != 0">
          <b-col class="text-center">
            <h3 class="ml-1">
              เอกสารจากผู้ร้อง
            </h3>
          </b-col>
        </b-row>

        <b-row
          v-if="this.attachFileDate !== null && this.attachFiles.length != 0"
        >
          <b-col cols="8" class="mt-2 text-center">
            ประเภทไฟล์/ ชื่อไฟล์
          </b-col>
          <b-col cols="4" class="mt-2 text-center">
            วันที่แนบเอกสาร
          </b-col>
          <!-- <b-col cols="2" class="mt-2 text-center">
            ดาวน์โหลด
          </b-col> -->
        </b-row>
        <!-- <div
            v-for="(date, index) in this.attachFiles"
            :key="index"
            class="m-1"
          > -->
        <!-- <h4 v-if="filterAttachFile(date).length > 0">
              {{ date }}
            </h4> -->

        <b-row
          v-for="file in this.filterAttachFileOld()"
          :key="file.attachId"
          class="col-12 m-1"
        >
          <b-col cols="8">
            <small>{{ file.masterDescription }}</small>
            <br />
            <!-- ใช้สำหรับ download ไฟล์ที่ไม่สามารถเปิดบน browser ได้ -->
            <a
              v-if="file.extension === 'txt'"
              @click="downloadAttachFile(file)"
              href="#"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-arrow-down-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="8 12 12 16 16 12" />
                <line x1="12" y1="8" x2="12" y2="16" />
              </svg>
              {{ file.fileName }}
            </a>
            <a
              v-else
              :href="file.filePath"
              :download="file.fileName"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-arrow-down-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="8 12 12 16 16 12" />
                <line x1="12" y1="8" x2="12" y2="16" />
              </svg>
              {{ file.fileName }}
            </a>
          </b-col>
          <b-col cols="4" class="d-flex justify-content-center">
            {{ file.createDateStr }}
          </b-col>

          <!-- <b-col cols="2" class="d-flex justify-content-center">
            {{ file.downloadCount }}
          </b-col> -->
          <b-col cols="1" class="d-flex justify-content-center">
            <a
              v-if="file.isAdd === true"
              href="javascript:void(0)"
              class="text-danger"
              @click="emitDeleteFile(file.attachId)"
            >
              <feather-icon icon="Trash2Icon" size="24" />
            </a>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <h3 class="ml-1">
              เอกสารเพิ่มเติมจากเจ้าหน้าที่
            </h3>
          </b-col>
        </b-row>

        <b-row v-if="this.attachFilesType2 !== null">
          <b-col cols="8" class="mt-2 text-center">
            ประเภทไฟล์/ ชื่อไฟล์
          </b-col>
          <b-col cols="4" class="mt-2 text-center">
            วันที่แนบเอกสาร
          </b-col>
          <!-- <b-col cols="2" class="mt-2 text-center">
            ดาวน์โหลด
          </b-col> -->
        </b-row>

        <!-- <div
          v-for="(date, index) in this.attachFileDateType2"
          :key="index"
          class="m-1"
        >
          <h4 v-if="filterAttachFileType2(date).length > 0">
            {{ date }}
          </h4> -->

        <b-row
          v-for="file in attachFilesType2"
          :key="file.attachId"
          class="col-12 m-1"
        >
          <b-col cols="8">
            <small>{{ file.masterDescription }}</small>
            <br />
            <a :href="file.filePath" :download="file.fileName" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-arrow-down-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="8 12 12 16 16 12" />
                <line x1="12" y1="8" x2="12" y2="16" />
              </svg>
              {{ file.fileName }}
            </a>
          </b-col>
          <b-col cols="4" class="d-flex justify-content-center">
            {{ file.createDateStr }}
          </b-col>

          <!-- <b-col cols="2" class="d-flex justify-content-center">
            {{ file.downloadCount }}
          </b-col> -->
          <b-col cols="1" class="d-flex justify-content-center">
            <a
              v-if="file.isAdd === true"
              href="javascript:void(0)"
              class="text-danger"
              @click="emitDeleteFile(file.attachId)"
            >
              <feather-icon icon="Trash2Icon" size="24" />
            </a>
          </b-col>
        </b-row>
        <!-- </div> -->

        <hr />

        <div class="m-1 mt-3">
          <b-row
            v-for="file in filterAttachFileNew()"
            :key="file.attachId"
            class="col-12 m-1"
          >
            <b-col cols="6">
              <a
                :href="file.filePath"
                :download="file.fileName"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-arrow-down-circle"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="8 12 12 16 16 12" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                </svg>
                {{ file.fileName }}
              </a>
            </b-col>
            <b-col cols="5" class="d-flex justify-content-center">
              {{ file.masterDescription }}
            </b-col>
            <!-- <b-col cols="1" class="d-flex justify-content-center">
              {{ file.downloadCount }}
            </b-col> -->
            <b-col cols="1" class="d-flex justify-content-center">
              <a
                v-if="file.isAdd === true"
                href="javascript:void(0)"
                class="text-danger"
                @click="emitDeleteFile(file.attachId)"
              >
                <feather-icon icon="Trash2Icon" size="24" />
              </a>
            </b-col>
          </b-row>
        </div>

        <b-row class="mt-2" v-if="this.IsEdit_TabAttachFiles === true">
          <b-col cols="12 mt-2">
            <h4>แนบเอกสารเพิ่มเติม</h4>
          </b-col>
          <b-col md="6">
            <b-form-select v-model="selected" :options="attachTypes" class="" />
          </b-col>
          <b-col md="6">
            <b-overlay :show="fileOverlay" rounded="sm">
              <b-form-file
                @change="onUploadFileChanged"
                ref="file-input"
                multiple
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-overlay>
          </b-col>
          <b-col md="12" class="mt-2 d-flex justify-content-center">
            <!-- <b-button variant="primary"
          @click="onUploadBtnClicked"
        >
          Upload
        </b-button> -->
          </b-col>
        </b-row>
      </b-tab>
      <b-tab id="tab-attach-2" title="เอกสารประกอบเรื่องร้องเรียน">
        <b-row>
          <b-col cols="6" class="mt-2 text-center">
            ชื่อไฟล์
          </b-col>

          <b-col cols="6" class="mt-2 text-center">
            หน่วยงาน / สถานะ
          </b-col>

          <!-- <b-col cols="3" class="mt-2 text-center">
            จำนวนดาวน์โหลด
          </b-col> -->
        </b-row>
        <div
          v-for="(date, index) in this.fileFormstatusModelDates"
          :key="index"
          class="m-1 ml-2"
        >
          <h4 v-if="filterAttachFileForm(date).length > 0">
            {{ date }}
          </h4>

          <b-row
            v-for="file in filterAttachFileForm(date)"
            :key="file.attachId"
            class="col-12 m-1"
          >
            <b-col cols="4">
              <a
                :href="file.filePath"
                :download="file.fileName"
                target="_blank"
              >
                <b-icon
                  icon="star-fill"
                  animation="fade"
                  font-scale="4"
                ></b-icon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-arrow-down-circle"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="8 12 12 16 16 12" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                </svg>
                {{ file.fileName }}
              </a>
            </b-col>
            <b-col cols="7" class="d-flex justify-content-center">
              {{ file.name }}
              <br />
              {{ file.leveldescription }} {{ file.statusdescription }}
            </b-col>
            <!-- <b-col cols="1" class="d-flex justify-content-center">
              {{ file.qty }}
            </b-col> -->
          </b-row>
        </div>
      </b-tab>
    </b-tabs>
  </b-tab>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BCard,
  BFormSelect,
  BButton,
  BFormFile,
  BOverlay,
} from "bootstrap-vue";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as storeMaster from "@/store/api/master/index.js";

import TabDocumentTrackingDetail from "../components/TabAttachFilesSystemDocument.vue";

import appsettings from "@/store/app-settings";

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormSelect,
    BButton,
    BFormFile,
    BOverlay,
    storeFileUpload,
    storeMaster,
    TabDocumentTrackingDetail,
  },
  props: {
    attachFiles: [],
    attachFileDate: [],
    attachFilesType2: [],
    attachFileDateType2: [],
    fileFormstatusModel: [],
    fileFormstatusModelDates: [],
    IsEdit_TabAttachFiles: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      attachTypes: [
        { value: null, text: "ประเภทเอกสาร", disabled: true },
        { text: "ประเภท1", value: 1 },
        { text: "ประเภท2", value: 2 },
        { text: "ประเภท3", value: 2 },
      ],
      selected: 13,
      files: [],
      fileOverlay: false,
    };
  },
  created() {
    //console.log('created')
    this.getFileType();
  },
  methods: {
    getFileType() {
      const _this = this;
      storeMaster
        .getMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onUploadBtnClicked() {
      console.log("this.files", this.attachFiles);
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }

      const _this = this;
      _this.fileOverlay = true;

      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        _this.fileOverlay = false;
        return;
      }
      selectedFiles.forEach(function(value, index) {
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;

      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected
        );
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            fileType: _this.selected,
            masterId: _this.selected,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            // console.log(response);
            response.data.data.forEach(function(value, index) {
              //console.log('emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
            _this.fileOverlay = false;
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    onActiveTabChange(newTabIndex) {
      console.log("subta");
      this.emitTabChange(newTabIndex);
    },
    emitUploadFile(file) {
      console.log("handleUpload");
      this.$emit("handle-upload", file);
    },
    emitDeleteFile(id) {
      console.log("emitDeleteFile", id);
      this.$emit("handle-delete", id);
    },
    emitTabChange(index) {
      console.log("emitTabChange", index);
      this.$emit("handle-tab-change", index);
    },
    // filterAttachFile(date) {
    //   try {
    //     console.log("child attach", this.attachFiles, this.attachFileDate);

    //     if (this.attachFiles === undefined || this.attachFileDate === undefined)
    //       return [];

    //     const filterAttach = this.attachFiles.filter((value) => {
    //       return value.createDateStr === date && value.isAdd === false;
    //     });

    //     return filterAttach;
    //   } catch (ex) {
    //     return [];
    //   }
    // },

    // filterAttachFileType2(date) {
    //   try {
    //     console.log(
    //       "child attach",
    //       this.attachFilesType2,
    //       this.attachFileDateType2
    //     );

    //     if (
    //       this.attachFilesType2 === undefined ||
    //       this.attachFileDateType2 === undefined
    //     )
    //       return [];

    //     const filterAttach = this.attachFilesType2.filter((value) => {
    //       return value.createDateStr === date && value.isAdd === false;
    //     });

    //     return filterAttach;
    //   } catch (ex) {
    //     return [];
    //   }
    // },
    filterAttachFileNew() {
      try {
        if (this.attachFiles === undefined) return [];

        const filterAttach = this.attachFiles.filter((value) => {
          return value.isAdd === true;
        });

        return filterAttach;
      } catch (ex) {
        return [];
      }
    },
    filterAttachFileOld() {
      try {
        if (this.attachFiles === undefined) return [];

        const filterAttach = this.attachFiles.filter((value) => {
          return value.isAdd !== true;
        });
        console.log("filterAttach", filterAttach);

        filterAttach.forEach(async (item) => {
          item.extension = item.fileName.split(".").slice(-1)[0];
        });

        console.log("filterAttach slice(-1)", filterAttach);

        return filterAttach;
      } catch (ex) {
        return [];
      }
    },
    filterAttachFileForm(date) {
      try {
        //console.log('fileFormstatusModel', this.fileFormstatusModel, 'fileFormstatusModelDates', this.fileFormstatusModelDates)
        if (
          this.fileFormstatusModel === undefined ||
          this.fileFormstatusModelDates === undefined
        )
          return [];

        const filterAttach = this.fileFormstatusModel.filter((value) => {
          return value.createTrackingStr === date;
        });

        //console.log('filterAttach', this.filterAttach)

        return filterAttach;
      } catch (ex) {
        return [];
      }
    },
    downloadAttachFile(item) {
      console.log("filterAttach item", item);
      const params = {
        complaintId:
          this.$route.query.id !== null &&
          this.$route.query.id !== undefined &&
          this.$route.query.id !== ""
            ? this.$route.query.id
            : null,
        attachId: item.attachId,
      };
      console.log("filterAttach params", params);

      let attachUrl = appsettings.complaintDownloadAttach
        .replace("{0}", params.complaintId)
        .replace("{1}", params.attachId);
      console.log("filterAttach attachUrl", item);
      window.open(attachUrl, "_blank");
    },
    onValidateExtensionFiles(selectedFiles, section) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs["file-input"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
  },
  computed: {},
};
</script>

<style></style>
